import tradewebLogo from "../Assets/Experiences/tradeweb.png";
import quickFiLogo from "../Assets/Experiences/quickfi.png";
import cornellCMSLogo from "../Assets/Experiences/cornell-cms.png";
import sailboatLogo from "../Assets/Experiences/sailboat.png";
import cornellLogo from "../Assets/Experiences/cornell.png";

export const experiences = [
  {
    title: "Software Engineering Intern",
    company: "Tradeweb",
    location: "New York",
    period: "June 2026 to Present",
    logo: tradewebLogo,
    blurb:
      "I reworked how the platform finds things, off Oracle and onto Elasticsearch and Redis, with Kafka keeping the index current as data changes. Redis handles recency, Elasticsearch the filtering, and feature flags let us fall back if we have to. A load-testing harness made the difference plain: heavy search paths dropped from hundreds of milliseconds to about five. The services run on Kubernetes, and the results show up in the web clients people already use.",
  },
  {
    title: "Software Engineering Intern",
    company: "QuickFi",
    location: "Fairport, NY",
    period: "May 2025 to May 2026",
    logo: quickFiLogo,
    blurb:
      "I built a language-model system that reads insurance certificates around the clock. Collection cycle time fell by about 60%, and most verifications never need a person. An email pipeline follows up when something is missing, escalates when it has to, and Salesforce stopped needing two hundred manual entries a day.",
  },
  {
    title: "Software Developer",
    company: "Cornell CMSX",
    location: "Ithaca",
    period: "September 2025 to Present",
    logo: cornellCMSLogo,
    blurb:
      "CMSX is the course system more than eight thousand Cornell students touch every semester. I ship across the stack, including a PeopleSoft enrollment sync that keeps rosters honest during add/drop. I also cleaned up how we serialize API responses, fixed time-ordering bugs in the feed, and put JUnit and Selenium around the academic workflows that cannot afford to break.",
  },
  {
    title: "Software Lead",
    company: "Cornell Autonomous Sailboat",
    location: "Ithaca",
    period: "November 2024 to Present",
    logo: sailboatLogo,
    blurb:
      "I led a team of twenty to first place at the 2025 International Robotic Sailing Regatta. The software is a ROS 2 navigation stack with a clean split between control, sensing, and mission logic, and firmware on a Teensy that turns those decisions into sail and rudder over serial.",
  },
  {
    title: "Undergraduate Researcher",
    company: "Cornell Duffield College of Engineering",
    location: "Ithaca",
    period: "January 2026 to Present",
    logo: cornellLogo,
    blurb:
      "I built a pipeline that reads privacy policies from more than 190 vendors and scores them across five stages of the data lifecycle. A rubric with an extra reasoning step brought the model closer to how a librarian would judge. Past about 400 tokens the scores started to drift; segmented prompts brought them back in line with expert ground truth.",
  },
];

export const nowItems = [
  {
    company: "Tradeweb",
    role: "Software Engineering Intern",
    note: "I am rebuilding how the platform searches by moving it off Oracle onto Elasticsearch and Redis. The new path runs through Kafka and Kubernetes, and the heavy queries now take about 5 milliseconds instead of 300.",
  },
  {
    company: "Cornell CMSX",
    role: "Software Developer",
    note: "I work across the stack on the course system more than 8,000 Cornell students use. Lately that has meant a PeopleSoft enrollment sync, cleaner API responses, and tests around the workflows that cannot break.",
  },
  {
    company: "CUSail",
    role: "Software Lead",
    note: "I lead software for a team of twenty, including a ROS 2 navigation stack and firmware on a Teensy for sail and rudder. We took first place at the 2025 International Robotic Sailing Regatta.",
  },
  {
    company: "Duffield College of Engineering",
    role: "Undergraduate Researcher",
    note: "I use language models to classify and score privacy policies from more than 190 vendors. One thing we found is that past about 400 tokens the scores start to drift.",
  },
];
